// ==============================
// CONFIGURACIÓN: RELOJ DATEJUST
// ==============================

const datejustConfig = {
  case: "fluted",
  size: "36mm",
  bracelet: "jubilee",
  dial: "1",
  hands: "1",
  date: "date"
};

const DATEJUST_TOTAL_DIALS = 27;
const DATEJUST_IMG_PARTS = ["case", "bracelet", "dial", "hands", "date"];

// ===========================
// FUNCIÓN PARA CAMBIAR CAPAS
// ===========================
function updateDatejustLayer(part, value) {
  datejustConfig[part] = value;

  // Tamaño no tiene capa visual
  if (part === "size") return;

  const img = document.getElementById(`dj-${part}`);
  if (!img) return;

  // Caso especial: si es "Sin fecha", ocultar la capa en vez de cargar imagen
  if (part === "date" && value === "no-date") {
    img.style.display = "none";
    img.removeAttribute("src");
    return;
  }
  // Si vuelve a una opción válida, asegurar que esté visible
  if (part === "date") {
    img.style.display = "";
  }

  const cdn = window.SHOPIFY_IMAGE_CDN || "";
  const val = part === "hands" ? `h${value}` : value;
  img.src = `${cdn}config-datejust-${part}-${val}.png`;
}

// =========================
// MARCAR OPCIÓN COMO ACTIVA
// =========================
function setActiveDatejustOption(part, value) {
  document.querySelectorAll(`[data-part="${part}"]`).forEach((opt) => {
    opt.classList.remove("active");
  });
  const selected = document.querySelector(`[data-part="${part}"][data-value="${value}"]`);
  if (selected) selected.classList.add("active");
}

// =========================
// GENERAR LOS 27 DIALS
// =========================
function buildDatejustDials() {
  const container = document.getElementById("dj-dials-container");
  if (!container) return;
  const cdn = window.SHOPIFY_IMAGE_CDN || "";

  for (let i = 1; i <= DATEJUST_TOTAL_DIALS; i++) {
    const div = document.createElement("div");
    div.className = "dj-option";
    div.dataset.part = "dial";
    div.dataset.value = String(i);
    div.innerHTML =
      `<img src="${cdn}config-datejust-dial-${i}.png" alt="Dial ${i}"/>` +
      `<span>Dial ${i}</span>`;
    container.appendChild(div);
  }
}

// ==========================
// INIT
// ==========================
document.addEventListener("DOMContentLoaded", () => {
  // Generar dials dinámicos
  buildDatejustDials();

  // Marcar opciones iniciales activas
  Object.keys(datejustConfig).forEach((part) => {
    setActiveDatejustOption(part, datejustConfig[part]);
  });

  // Setear imágenes del preview principal en CDN
  DATEJUST_IMG_PARTS.forEach((part) => {
    updateDatejustLayer(part, datejustConfig[part]);
  });

  // Click en cualquier opción
  document.querySelectorAll(".dj-option").forEach((option) => {
    option.addEventListener("click", function () {
      const part = this.getAttribute("data-part");
      const value = this.getAttribute("data-value");
      if (!part || !value) return;
      updateDatejustLayer(part, value);
      setActiveDatejustOption(part, value);
    });
  });

  // Botón compra (si existe)
  const buyBtn = document.getElementById("buyBtn");
  if (buyBtn) buyBtn.addEventListener("click", buyCurrentProductDatejust);
});

// ==========================
// COMPRA POR WHATSAPP
// ==========================
function buyCurrentProductDatejust() {
  const phoneNumber = "5491137003736";
  const LABELS = {
    case: "Caja", size: "Tamaño", bracelet: "Brazalete",
    dial: "Dial", hands: "Agujas", date: "Fecha"
  };

  let message = `Hola, quiero comprar un Datejust personalizado.\n\nConfiguración elegida:\n`;
  Object.keys(datejustConfig).forEach((part) => {
    const spanEl = document.querySelector(
      `.dj-option[data-part="${part}"][data-value="${datejustConfig[part]}"] span`
    );
    const label = spanEl ? spanEl.textContent.trim() : datejustConfig[part];
    message += `• ${LABELS[part]}: ${label}\n`;
  });

  const encodedMessage = encodeURIComponent(message);
  window.open(`https://wa.me/${phoneNumber}?text=${encodedMessage}`, "_blank");
}

// Alias para HTML local (datejust.html)
function buyCurrentProduct() {
  buyCurrentProductDatejust();
}

// ------------------------------------------------------------------
// MENÚ MÓVIL Y DROPDOWNS
// ------------------------------------------------------------------
function toggleMobileMenu() {
  const mobileNav = document.getElementById("mobile-nav");
  const mobileToggle = document.querySelector(".mobile-menu-toggle");
  if (!mobileNav || !mobileToggle) return;
  mobileNav.classList.toggle("active");
  mobileToggle.classList.toggle("active");
}

function toggleMobileDropdown(event) {
  event.preventDefault();
  event.stopPropagation();
  const dropdown = event.currentTarget.closest(".mobile-dropdown");
  const dropdownMenu = dropdown.querySelector(".mobile-dropdown-menu");
  if (!dropdown || !dropdownMenu) return;
  document.querySelectorAll(".mobile-dropdown-menu").forEach((menu) => {
    if (menu !== dropdownMenu) menu.classList.remove("active");
  });
  dropdownMenu.classList.toggle("active");
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".mobile-nav-link").forEach((link) => {
    link.addEventListener("click", (e) => {
      if (link.classList.contains("dropdown-toggle")) {
        e.preventDefault();
        return;
      }
      const mobileNav = document.getElementById("mobile-nav");
      const mobileToggle = document.querySelector(".mobile-menu-toggle");
      if (mobileNav && mobileToggle) {
        mobileNav.classList.remove("active");
        mobileToggle.classList.remove("active");
      }
    });
  });
});

// ==========================
// SHOPIFY CART (fallback)
// ==========================
function addToShopifyCart_datejust() {
  const variantId =
    window.DATEJUST_VARIANT_ID ||
    (window.SHOPIFY_VARIANTS && window.SHOPIFY_VARIANTS["datejust"]);
  if (!variantId) { console.error("No variant ID for datejust"); return; }

  const properties = {};
  for (const k in datejustConfig) properties[k] = datejustConfig[k];

  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id: variantId, quantity: 1, properties })
  })
    .then((r) => r.json())
    .then(() => { window.location.href = "/cart"; })
    .catch(() => { alert("Error al agregar. Intenta de nuevo."); });
}
